import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { useHistory } from "react-router-dom";
import Asignacion  from 'src/services/asignacion';
import { Input } from '@material-ui/core';





const columns = [
 
  { id: 'ps_nombre', 
  label: 'Punto de Servicio', 
  align: 'left',
  minWidth: 90,
  format: (value) => value.toFixed(0),
},

];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 600,
    maxWidth:370,
  },
  filtro: {
    width: '100%',
    height: '40px',
  }
});

export default function StickyHeadTable() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searchValue, setSearchValue] = React.useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);

  };

  const navigate = useHistory()

 
  
  function  handleChangeView(row) {
  sessionStorage.setItem('ps_id', row['ps_id'] )
  sessionStorage.setItem('ps_nombre', row['ps_nombre'])
  navigate.push(`/asignacionDetalle`)
  
  }

 

  //configurar hooks
  const [rows, setRows] = useState([{}]);


  useEffect(() => {
    (async () => {
      await loadData();
      
    })();
  },[])

const loadData = async () => {

    const url = await Asignacion.AsignacionAPI()
    const response = url
    setRows(response)
}

const onFilterOperario = (event) =>{
    
  setSearchValue(event.target.value);
}

let searchedValueOperario = [{}];

if(!searchValue.length){

  searchedValueOperario = rows;
}else{

  searchedValueOperario = rows.filter(rows => { 
    const searchText = rows['ps_nombre'].toLowerCase();
    const searchedText = searchValue.toLowerCase();
    return searchText.includes(searchedText);
  } )
  
}

  return (


    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
      <Input
        value={searchValue}
        className={classes.filtro}
        onChange={onFilterOperario}
        placeholder='Buscar Punto de servicio'
        />
        <Table stickyHeader aria-label="sticky table">
        
          <TableHead> 
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align='center'
                  style={{ minWidth: column.minWidth, background: '#910434', color: 'whitesmoke', fontWeight: 'bold' }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {searchedValueOperario.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              const uniqueKey = index
              return (
                <TableRow onClick={function id(){ return  handleChangeView(row);}}  hover role="checkbox"  tabIndex={-1} key={uniqueKey} >
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align='center'>
                        {column && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
        rowsPerPageOptions={[5,15,30]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      </TableContainer>
     
    </Paper>
  );
}